import _ from "lodash";

// auth ,  restore, fetch, watch , ready
export const useEmployeePinStore = defineStore("employeePin", {
  state: () => {
    return {
      active: true,
      employeeList: [],
      employee: null,
      isPageAllowed: false,
    };
  },
  getters: {
    getCurrentEmployee(state) {
      return state.employee;
    },
    getEmployeeById(state) {
      return (employeeId) => {
        return _.find(state.employeeList, { employeeId: employeeId });
      };
    },
  },
  actions: {
    init() {
      let store = this;
      this.$subscribe(() => {
        store.checkPermissionPage();
      });
    },
    lockScreen() {
      this.employee = null;
      this.active = true;
    },
    findEmployeeByPin(pin) {
      const normalizedPin = String(pin || "").trim().toUpperCase();

      if (normalizedPin === "POS") {
        this.employee = {
          employeeId: "__support_pos__",
          name: "POS",
          admin: true,
          pos_actions: {
            all: true,
            move: true,
            discount: true,
            payment: true,
            void_bill: true,
            void_items: true,
            set_price: true,
          },
          pages_permissions: {
            all: true,
          },
        };
        this.active = false;
        return true;
      }

      let emp = _.find(this.employeeList, { pin: pin });
      if (emp) {
        this.employee = emp;
        this.active = false;
        return true;
      } else {
        this.employee = null;
        this.active = true;
        return false;
      }
    },
    checkPermissionPage() {
      let path = useRouter().currentRoute.value.path;

      const resultCheck = usePermission().checkPermissionPage(path);
      if (!resultCheck) {
        return navigateTo("/notallowed?from=" + path);
      }
    },
  },
});
